import { render, staticRenderFns } from "./FieldText.vue?vue&type=template&id=12eca90b"
import script from "./FieldText.vue?vue&type=script&lang=js"
export * from "./FieldText.vue?vue&type=script&lang=js"
import style0 from "./FieldText.vue?vue&type=style&index=0&id=12eca90b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QIcon,QField,QCheckbox});
